<!-- <p>custom-dashboard works!</p> -->
<ng-template #PageLoadingTemplate>
    <app-loading-template DisplayText="Please wait while we load dashboard information" />
</ng-template>
<div class="dbv-main" #dbv_main id="dbv_main"
    *ngIf="(useDashboardViewer && publicPanelData && panelInfo && selectedDashboard && templates && hierarchyTemplates) else PageLoadingTemplate">

    @if (isFullscreen) {
    <div class="fullscreen-watermark">
        <span class="fullscreen-dashboard-title">{{selectedDashboard.DashboardName}}</span>
        <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/Logo%20-%20PRISMPdM.png">
        <button mat-icon-button (click)="trueFullscreen(dbv_main, !isFullscreen)">
            <mat-icon>{{isFullscreen ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
        </button>
    </div>
    <ng-container *ngTemplateOutlet="AccountExpired"></ng-container>
    }@else{
    <div class="dashboard-title alignRow">
        <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='existingDashboards'
            [value]="selectedDashboard.OrganisationDashboardID" [fields]="dasboardFields"
            (change)="selectDashboard($event)" [popupWidth]="'150%'">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.DashboardName }}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
        <button style="margin-left: 0.5em;" mat-raised-button (click)="setAsDefault()"
            [disabled]="selectedDashboard.UserDefault">{{!selectedDashboard.UserDefault ?
            'Set as Default': 'Default'}}</button>
        <button mat-raised-button style="margin-left: 0.5em;" [matMenuTriggerFor]="timeMenu"
            #timeTrigger="matMenuTrigger">
            <span>Period</span>
            <mat-icon>edit</mat-icon>
        </button>
        <mat-menu #timeMenu="matMenu">
            <div style="margin: 1em;">
                <span>Date Range:</span>
                <app-date-range-picker (datePickerChange)="DatePickerChange($event)"
                    [matMenuTrigger]="timeTrigger"></app-date-range-picker>
                <br><br>
                <span>Duration:</span>
                <app-duration-selector [(duration)]="strDuration"
                    (durationChange)="selectNumDays($event)"></app-duration-selector>
            </div>
        </mat-menu>
        <div class="period-info" *ngIf="startDate && endDate">
            <span>{{numDays <= 1 ? (numDays * 24).toFixed(0) : numDays}} {{numDays <=1 ? "Hours" : "Days" }}
                    ({{getShortDate(startDate)}} - {{getShortDate(endDate)}})</span>
        </div>
        <span class="toolbar-spacer"></span>
        <button mat-raised-button color="primary" (click)="editDashboard()"
            *ngIf="((thisUser && thisUser.AdminSite) || (selectedAccount && selectedAccount.Admin)) && !selectedDashboard.Locked"
            [disabled]="selectedDashboard.Locked">
            <span>Edit Dashboard</span>
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="trueFullscreen(dbv_main, !isFullscreen)">
            <mat-icon>{{isFullscreen ? 'fullscreen_exit' :
                'fullscreen'}}</mat-icon>
        </button>
    </div>
    }

    <div class="dbv-container">
        <app-dashboard-viewer [publicPanelData]="publicPanelData" [panelInfo]="panelInfo"
            [selectedDashboard]="selectedDashboard" [templates]="templates" [hierarchyTemplates]="hierarchyTemplates"
            [container]="dbv_main" [isFullScreen]="isFullscreen"></app-dashboard-viewer>
    </div>
</div>

@if (!isMobile && !useDashboardViewer) {
<div class="main" #main>
    @if (isFullscreen) {
    <div class="fullscreen-watermark">
        <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/Logo%20-%20PRISMPdM.png">
        <button mat-icon-button (click)="trueFullscreen(main, !isFullscreen)">
            <mat-icon>{{isFullscreen ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
        </button>
    </div>
    } @else {
    <div class="dashboard-title alignRow">
        <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='existingDashboards'
            [value]="selectedDashboard?.OrganisationDashboardID" [fields]="dasboardFields"
            (change)="selectDashboard($event)" [popupWidth]="'150%'">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.DashboardName }}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
        <button style="margin-left: 0.5em;" mat-raised-button (click)="setAsDefault()"
            [disabled]="selectedDashboard?.UserDefault">{{!selectedDashboard?.UserDefault ?
            'Set as Default': 'Default'}}</button>
        <!-- <button mat-raised-button style="margin-left: 0.5em;" [matMenuTriggerFor]="timeMenu">
            <span>Period</span>
            <mat-icon>edit</mat-icon>
        </button> -->
        <div class="period-info" *ngIf="startDate && endDate">
            <span>{{numDays <= 1 ? (numDays * 24).toFixed(0) : numDays}} {{numDays <=1 ? "Hours" : "Days" }}
                    ({{getShortDate(startDate)}} - {{getShortDate(endDate)}})</span>
        </div>
        <span class="toolbar-spacer"></span>
        <button mat-raised-button color="primary" (click)="editDashboard()"
            *ngIf="(thisUser && thisUser.AdminSite) || (selectedAccount && selectedAccount.Admin)"
            [disabled]="selectedDashboard?.Locked">
            <span>Edit Dashboard</span>
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="trueFullscreen(main, !isFullscreen)">
            <mat-icon>{{isFullscreen ? 'fullscreen_exit' :
                'fullscreen'}}</mat-icon>
        </button>
    </div>
    }
    <!-- !isFullscreen ? aspectRatio : fullScreenAspectRatio -->
    <!-- !isFullscreen ? maxColumns : computedColumns -->
    <div #dashboardContainer class="dashboard-container">
        <ejs-dashboardlayout id='dashboardLayout' #dashboardLayout [cellSpacing]='cellSpacing'
            [columns]="!isFullscreen ? maxColumns : computedColumns" [cellAspectRatio]='aspectRatio'
            [allowFloating]="false" [showGridLines]="false" [allowDragging]="false" [allowResizing]="false">
        </ejs-dashboardlayout>
    </div>
</div>
}

<div class="mobile-main" *ngIf="isMobile && !useDashboardViewer" #mobileMain>
    <div class="dashboard-title alignRow" *ngIf="!isFullscreen">
        <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='existingDashboards'
            [value]="selectedDashboard?.OrganisationDashboardID" [fields]="dasboardFields"
            (change)="selectDashboard($event)" [popupWidth]="'150%'">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.DashboardName }}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
        <button style="margin-left: 0.5em;" mat-raised-button (click)="setAsDefault()"
            [disabled]="selectedDashboard?.UserDefault">{{!selectedDashboard?.UserDefault ?
            'Set as Default': 'Default'}}</button>
        <!-- <button mat-raised-button style="margin-left: 0.5em;" [matMenuTriggerFor]="timeMenu">
            <span>Period</span>
            <mat-icon>edit</mat-icon>
        </button> -->
        <div class="period-info" *ngIf="startDate && endDate">
            <span>{{numDays <= 1 ? (numDays * 24).toFixed(0) : numDays}} {{numDays <=1 ? "Hours" : "Days" }}
                    ({{getShortDate(startDate)}} - {{getShortDate(endDate)}})</span>
        </div>
        <span class="toolbar-spacer"></span>
        <button mat-raised-button color="primary" (click)="editDashboard()"
            *ngIf="((thisUser && thisUser.AdminSite) || (selectedAccount && selectedAccount.Admin)) || !selectedDashboard?.Locked"
            [disabled]="selectedDashboard?.Locked">
            <span>Edit Dashboard</span>
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button class="alignRow" (click)="trueFullscreen(mobileMain, !isFullscreen)">
            <mat-icon>{{isFullscreen ? 'fullscreen_exit' :
                'fullscreen'}}</mat-icon>
        </button>
    </div>
    <div class="fullscreen-watermark" *ngIf="isFullscreen">
        <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/Logo%20-%20PRISMPdM.png">
        <button mat-icon-button class="alignRow" (click)="trueFullscreen(mobileMain, !isFullscreen)">
            <mat-icon>{{isFullscreen ? 'fullscreen_exit' :
                'fullscreen'}}</mat-icon>
        </button>
    </div>
    <!-- !isFullscreen ? mobileAspectRatio : fullScreenAspectRatio -->
    <div #mobileDashboardContainer class="mobile-dashboard-container">
        <ejs-dashboardlayout id='dashboardLayout' #dashboardLayout [cellSpacing]='cellSpacing'
            [columns]="!isFullscreen ? maxColumns : computedColumns" [cellAspectRatio]='mobileAspectRatio'
            [allowFloating]="false" [showGridLines]="false" [allowDragging]="false" [allowResizing]="false">
        </ejs-dashboardlayout>
    </div>
</div>

<ng-template #defaultPanelTemplate>
    <div class="default-panel alignRow alignColumn">
        <span>Drag a Node from the Data Model into this Tile</span>
    </div>
</ng-template>

<ng-template #gaugePanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <div class="parent-div" #parentDiv>
            <app-dashboard-gauge *ngIf="dashboardActive" [panelData]="panelData" [publicPanelData]="publicPanelData"
                [creating]="false" [refresh]="refreshGauges" (intervalFinish)="respondToIntervalFinish($event)"
                (borderChange)="respondToBorderChange(parentDiv, $event)"></app-dashboard-gauge>
        </div>
    </div>
</ng-template>

<ng-template #annotatedGaugePanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <div class="parent-div" #parentDiv>
            <app-dashboard-annotated-gauge *ngIf="dashboardActive" [panelData]="panelData"
                [publicPanelData]="publicPanelData" [creating]="false" [refresh]="refreshGauges" [isMobile]="isMobile"
                (intervalFinish)="respondToIntervalFinish($event)"
                (borderChange)="respondToBorderChange(parentDiv, $event)"></app-dashboard-annotated-gauge>
        </div>
    </div>
</ng-template>

<ng-template #chartPanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <app-dashboard-chart [panelData]="panelData" [publicPanelData]="publicPanelData" [creating]="false"
            [refresh]="refreshCharts" [numDays]="numDays" (intervalFinish)="respondToIntervalFinish($event)"
            (seriesChange)="updateChartBars($event.panelID, $event.barSeries)"></app-dashboard-chart>
    </div>
</ng-template>

<ng-template #textPanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <app-dashboard-text [panelData]="panelData" [publicPanelData]="publicPanelData" [creating]="false"
            (intervalFinish)="respondToIntervalFinish($event)"></app-dashboard-text>
    </div>
</ng-template>

<ng-template #listPanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <app-dashboard-list [panelData]="panelData" [publicPanelData]="publicPanelData" [creating]="false"
            (intervalFinish)="respondToIntervalFinish($event)"></app-dashboard-list>
    </div>
</ng-template>

<ng-template #linearGaugePanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <div class="parent-div" #parentDiv>
            <app-dashboard-linear-gauge [panelData]="panelData" [creating]="false" [publicPanelData]="publicPanelData"
                (intervalFinish)="respondToIntervalFinish($event)"
                (borderChange)="respondToBorderChange(parentDiv, $event)"></app-dashboard-linear-gauge>
        </div>
    </div>
</ng-template>

<ng-template #shortcutPanelTemplate let-panelData="data">
    <app-dashboard-shortcut [panelData]="panelData" [publicPanelData]="publicPanelData" [creating]="false"
        (buttonClicked)="respondToShortcutClick($event)"></app-dashboard-shortcut>
</ng-template>

<ng-template #watchListPanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <app-dashboard-watch-list style="height: 100%; width: 100%;" [accountID]="accountGUID"
            [OrganisationUID]="organisationUID" [panelData]="panelData" [creating]="false"></app-dashboard-watch-list>
    </div>
</ng-template>

<ng-template #actionsPanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <app-dashboard-action-list [accountID]="accountGUID" [organisationUID]="organisationUID" [panelData]="panelData"
            [creating]="false"></app-dashboard-action-list>
    </div>
</ng-template>

<ng-template #rulesPanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <app-dashboard-rules [accountGUID]="accountGUID" [organisationUID]="organisationUID" [creating]="false"
            [panelData]="panelData"></app-dashboard-rules>
    </div>
</ng-template>

<ng-template #eventsPanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <app-dashboard-events [accountGUID]="accountGUID" [organisationUID]="organisationUID" [creating]="false"
            [panelData]="panelData" [startTime]="startDate.getTime()"
            [endTime]="endDate.getTime()"></app-dashboard-events>
    </div>
</ng-template>

<ng-template #webhooksPanelTemplate let-panelData="data">
    <div class="header-container" #container>
        <app-panel-header [dashboardStartDate]="startDate" [dashboardEndDate]="endDate"
            [dashboardStrDuration]="strDuration" [containingDiv]="container" [dashboardFullscreen]="dashboardFullscreen"
            (panelFullscreen)="isFullscreen = $event"
            (customRange)="handleCustomRangeChange(panelData, $event)"></app-panel-header>
        <app-dashboard-webhooks style="width: 100%; height: 100%;" [accountGUID]="accountGUID"
            [organisationUID]="organisationUID" [panelData]="panelData" [creating]="false" [refresh]="refreshWebhooks"
            (beginWebhookInterval)="startWebhookInterval()"></app-dashboard-webhooks>
    </div>
</ng-template>

<ng-template #AccountExpired>
    @if (selectedAccountExpired) {
    <div class="watermark">
        <span class="text alignRow">
            <mat-icon>access_time</mat-icon>
            <span>&nbsp;{{expiredMessage}}</span>
        </span>
    </div>
    }
</ng-template>